import { render, staticRenderFns } from "./ManifestFormCreate.vue?vue&type=template&id=04f3b0bc&scoped=true"
import script from "./ManifestFormCreate.vue?vue&type=script&lang=js"
export * from "./ManifestFormCreate.vue?vue&type=script&lang=js"
import style0 from "./ManifestFormCreate.vue?vue&type=style&index=0&id=04f3b0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3b0bc",
  null
  
)

export default component.exports